import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
    OutterWrap,
    InnerWrap,
    ItemNumber,
    ItemNumberText,
    Question,
    Indicator,
    Answer,
    AnswerText,
    TextLink,
} from './styled';

class Item extends Component {
    onItemClick = () => {
        const { handleItemClick, index } = this.props;
        handleItemClick(index);
    };

    render() {
        const {
            className,
            isActive,
            title,
            description,
            withIcons,
            index,
            faqStyle,
            withHtml,
            shouldShowIndicator,
        } = this.props;

        return (
            <OutterWrap className={className}>
                <InnerWrap onClick={this.onItemClick} faqStyle={faqStyle}>
                    {withIcons && (
                        <ItemNumber>
                            <ItemNumberText>{index + 1}</ItemNumberText>
                        </ItemNumber>
                    )}
                    <Question>{title}</Question>
                    {shouldShowIndicator && <Indicator>{isActive ? '-' : '+'}</Indicator>}
                </InnerWrap>
                <Answer withIcons={withIcons} isActive={isActive}>
                    {withHtml ? (
                        <AnswerText html={description} overrides={{ a: TextLink }} />
                    ) : (
                        <AnswerText overrides={{ a: TextLink }}>{description}</AnswerText>
                    )}
                </Answer>
            </OutterWrap>
        );
    }
}

Item.propTypes = {
    handleItemClick: PropTypes.func,
    index: PropTypes.number.isRequired,
    className: PropTypes.string,
    isActive: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    withIcons: PropTypes.bool,
    faqStyle: PropTypes.string,
    withHtml: PropTypes.bool,
    shouldShowIndicator: PropTypes.bool,
};

Item.defaultProps = {
    isActive: false,
    title: null,
    description: null,
    withIcons: false,
    handleItemClick: () => {},
    className: '',
    faqStyle: '',
    withHtml: true,
    shouldShowIndicator: true,
};

export default Item;
